(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mon-avis-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mon-avis-video')) {
    customElements.define(
      'mon-avis-video',
      class extends HTMLElement {
        connectedCallback() {
          const piste = this.querySelector('[data-mav-piste]');
          const cartes = [...this.querySelectorAll('.mav__avis')];
          const precedent = this.querySelector('[data-mav-precedent]');
          const suivant = this.querySelector('[data-mav-suivant]');
          const compteur = this.querySelector('[data-mav-compteur]');
          if (piste && cartes.length && precedent && suivant) {
            const indexActuel = () => cartes.reduce((best, carte, index) =>
              Math.abs(carte.offsetLeft - piste.offsetLeft - piste.scrollLeft) <
              Math.abs(cartes[best].offsetLeft - piste.offsetLeft - piste.scrollLeft) ? index : best, 0);
            const actualiser = () => {
              const index = indexActuel();
              precedent.disabled = index === 0;
              suivant.disabled = index === cartes.length - 1;
              compteur.textContent = `${index + 1} / ${cartes.length}`;
            };
            const aller = (delta) => {
              const index = Math.max(0, Math.min(cartes.length - 1, indexActuel() + delta));
              piste.scrollTo({ left: cartes[index].offsetLeft - piste.offsetLeft,
                behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
              setTimeout(actualiser, 350);
            };
            precedent.addEventListener('click', () => aller(-1));
            suivant.addEventListener('click', () => aller(1));
            piste.addEventListener('scroll', actualiser, { passive: true });
            piste.addEventListener('keydown', (event) => {
              if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
                event.preventDefault();
                aller(event.key === 'ArrowRight' ? 1 : -1);
              }
            });
            actualiser();
          }
          this.querySelectorAll('[data-mav-plus]').forEach((bouton) => {
            const texte = bouton.previousElementSibling;
            if (!texte) return;
            const mesure = () => { if (!texte.classList.contains('is-expanded')) bouton.hidden = texte.scrollHeight <= texte.clientHeight + 2; };
            requestAnimationFrame(mesure);
            bouton.addEventListener('click', () => {
              const ouvert = texte.classList.toggle('is-expanded');
              bouton.textContent = ouvert ? 'Voir moins' : 'Voir plus';
              bouton.setAttribute('aria-expanded', String(ouvert));
            });
          });
          const lecteur = this.querySelector('[data-mav-lecteur]');
          const video = lecteur && lecteur.querySelector('video');
          if (!lecteur || !video) return;

          const ouvrir = (vignette) => {
            this.dispatchEvent(new CustomEvent('mav:dialog', { detail: { open: true } }));
            video.poster = vignette.dataset.mavApercu || '';
            video.src = vignette.dataset.mavSrc;
            lecteur.showModal();
            video.play().catch(() => {});
          };
          this.addEventListener('mav:open', event => ouvrir(event.detail.vignette));
          this.addEventListener('click', event => {
            const vignette = event.target.closest('[data-mav-ouvrir]');
            if (vignette && !vignette.closest('mon-ugc-carousel.is-ready')) ouvrir(vignette);
          });
          const fermer = () => lecteur.close();
          this.querySelector('[data-mav-fermer]').addEventListener('click', fermer);
          lecteur.addEventListener('click', (e) => {
            if (e.target === lecteur) fermer();
          });
          lecteur.addEventListener('close', () => {
            video.pause();
            this.dispatchEvent(new CustomEvent('mav:dialog', { detail: { open: false } }));
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mon-cookie-consent-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    const titleText = 'Cookies et confidentialité';
    /* Texte court sur téléphone, pour un bandeau compact. */
    const bodyText = window.matchMedia('(max-width: 749px)').matches
      ? 'Nous utilisons des cookies pour améliorer votre expérience et mesurer l’audience du site.'
      : 'Nous utilisons des cookies pour améliorer votre expérience et analyser le trafic de notre site. Vous pouvez choisir de les accepter ou de les refuser.';

    const applyMontroseCookieCopy = () => {
      if (!document.documentElement.lang.toLowerCase().startsWith('fr')) return;

      const banner = document.getElementById('shopify-pc__banner');
      if (!banner) return;

      const title = banner.querySelector('#shopify-pc__banner__body-title');
      if (title && title.textContent.trim() !== titleText) {
        title.textContent = titleText;
      }

      const paragraph = banner.querySelector('.shopify-pc__banner__body p');
      if (!paragraph || paragraph.dataset.monCopyApplied === 'true') return;

      const policyLink = paragraph.querySelector('#shopify-pc__banner__body-policy-link');
      paragraph.textContent = bodyText;

      if (policyLink) {
        paragraph.append(' ', policyLink);
      }

      paragraph.dataset.monCopyApplied = 'true';
    };

    applyMontroseCookieCopy();

    const observer = new MutationObserver(applyMontroseCookieCopy);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mon-description-produit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mon-description-produit')) {
    customElements.define('mon-description-produit', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected) return;
        this.text = this.querySelector('[data-mon-description-text]');
        this.button = this.querySelector('[data-mon-description-toggle]');
        if (!this.text || !this.button || this.controller) return;
        this.controller = new AbortController();
        this.links = new Map();
        this.expanded = false;
        this.button.addEventListener('click', () => {
          this.expanded = !this.expanded;
          this.render();
        }, { signal: this.controller.signal });
        this.measure();
        this.observer = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          const lineHeight = parseFloat(getComputedStyle(this.text).lineHeight);
          if (width === this.width && lineHeight === this.lineHeight) return;
          this.width = width;
          this.measure();
        });
        this.observer.observe(this);
        document.fonts?.ready.then(() => {
          if (this.isConnected) this.measure();
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.controller?.abort();
        this.restoreLinks();
        this.controller = null;
      }

      measure() {
        if (!this.text.getBoundingClientRect().width) return;
        const styles = getComputedStyle(this.text);
        const lineHeight = parseFloat(styles.lineHeight) || parseFloat(styles.fontSize) * 1.5;
        this.lineHeight = lineHeight;
        this.preview = lineHeight * 3;
        this.style.setProperty('--mon-description-preview', `${this.preview}px`);
        this.overflowing = this.text.scrollHeight > this.preview + 1;
        this.render();
      }

      restoreLinks() {
        this.links?.forEach((tabindex, link) => {
          if (tabindex === null) link.removeAttribute('tabindex');
          else link.setAttribute('tabindex', tabindex);
          link.removeAttribute('data-mon-description-clipped');
        });
        this.links?.clear();
      }

      render() {
        const collapsed = this.overflowing && !this.expanded;
        this.classList.toggle('is-collapsed', collapsed);
        this.button.hidden = !this.overflowing;
        this.button.setAttribute('aria-expanded', String(this.overflowing && this.expanded));
        this.button.textContent = this.expanded && this.overflowing ? this.dataset.less : this.dataset.more;
        this.restoreLinks();
        if (!collapsed) return;
        const bottom = this.text.getBoundingClientRect().top + this.preview;
        this.text.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(link => {
          if (link.getBoundingClientRect().bottom <= bottom) return;
          this.links.set(link, link.getAttribute('tabindex'));
          link.setAttribute('tabindex', '-1');
          link.setAttribute('data-mon-description-clipped', '');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
